import { render, staticRenderFns } from "./PartnerLogoBelt.vue?vue&type=template&id=79f104b1&"
import script from "./PartnerLogoBelt.vue?vue&type=script&lang=ts&"
export * from "./PartnerLogoBelt.vue?vue&type=script&lang=ts&"
import style0 from "./PartnerLogoBelt.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports